var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_181",
    "data-name": "Group 181",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.722,
    height: 19.723,
    viewBox: "0 0 19.722 19.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M13.987,19.723H5.738A5.743,5.743,0,0,1,0,13.986V5.737A5.743,5.743,0,0,1,5.738,0h8.249a5.744,5.744,0,0,1,5.737,5.737v8.249a5.743,5.743,0,0,1-5.737,5.737m-8.249-18A4.018,4.018,0,0,0,1.724,5.737v8.249A4.018,4.018,0,0,0,5.738,18h8.249A4.018,4.018,0,0,0,18,13.986V5.737a4.018,4.018,0,0,0-4.014-4.014Z",
    transform: "translate(-0.001)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M99.944,104.986a5.043,5.043,0,1,1,5.043-5.043,5.049,5.049,0,0,1-5.043,5.043m0-8.363a3.32,3.32,0,1,0,3.32,3.32,3.324,3.324,0,0,0-3.32-3.32",
    transform: "translate(-90.083 -90.082)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M276.718,68.063a1.2,1.2,0,1,0-1.2,1.2,1.2,1.2,0,0,0,1.2-1.2",
    transform: "translate(-260.383 -63.464)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramDark);
export default __webpack_public_path__ + "static/media/instagram-dark.8320eb42de814056926f1325071e5ae1.svg";
export { ForwardRef as ReactComponent };